import { Injectable } from '@angular/core';

Injectable();
@Injectable()
export class Globals {
    public openModal = (entries, titleText ?, showCloseBtn ?, backdropClickClose ?, modalSize?) => {
    }
    constructor() { }
}
